﻿export function setupFleetNewsUserData() {
    $(document).on("submit", "[data-fleetnews-user-data-form]", submitUserDataForm);
    $(document).on("submit", "[data-fleetnews-user-data-close-form]", closeForm);
}

function closeForm(e) {
    const form = $(e.target);
    if (!form.valid())
        return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function (response) {
        $("[data-fleetnews-user-data]").remove();
    });
}

function submitUserDataForm(e) {
    const toChooseMyNextCompanyCarButton = $("#ToChooseMyNextCompanyCarButton").attr("class");
    if (toChooseMyNextCompanyCarButton.indexOf("active") > -1) {
        $("#ToChooseMyNextCompanyCar").val(true);
    }
    const toManageMyCompanyFleetButton = $("#ToManageMyCompanyFleetButton").attr("class");
    if (toManageMyCompanyFleetButton.indexOf("active") > -1) {
        $("#ToManageMyCompanyFleet").val(true);
    }
    const otherButton = $("#OtherButton").attr("class");
    if (otherButton.indexOf("active") > -1) {
        $("#Other").val(true);
    }
    const form = $(e.target);
    if (!form.valid())
        return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function (response) {
        $("[data-fleetnews-user-data]").remove();
    });
}
